'use strict';

// <chart data="[]" type="Line" width="720" height="200" />
function chart() {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    template: '<canvas></canvas>',
    link: ($scope, $element, $attrs) => {
      const canvas = $element.find('canvas')[0];
      const ctx = canvas.getContext('2d');

      canvas.width = $attrs.width;
      canvas.height = $attrs.height;
      let chrt = new Chart(ctx);

      $scope.$watch('data', (val) => {
        chrt[$attrs.type](val, {
          animationEasing: 'linear',
          animationSteps: 30
        });
      }, true);
    }
  };
}

angular
  .module('sr.chart', [])
  .directive('chart', chart);
